<template>
    <div class="post-manage">
        <el-card class="filter-card">
            <div slot="header" class="clearfix">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item>岗位管理</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="70px">
                <el-form-item label="系统">
                    <el-select size="small" v-model="formInline.companyId" placeholder="请选择系统" clearable>
                        <el-option
                            v-for="item in companyOptions"
                            :key="item.companyId"
                            :label="item.companyName"
                            :value="item.companyId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button size="mini" icon="el-icon-search" type="primary" @click="onSubmit">查 询</el-button>
                    <el-button size="mini" icon="el-icon-plus" type="primary" @click="changePostInfo">新 增</el-button>
                    <el-button size="mini" icon="el-icon-document-copy" type="primary" @click="copyPosition">复 制</el-button>
                </el-form-item>
                <!-- <el-form-item label="岗位名称">
                    <el-input size="small" v-model="formInline.positionName" placeholder="请输入岗位名称"></el-input>
                </el-form-item>
                <el-form-item label="岗位编码">
                    <el-input size="small" v-model="formInline.positionCode" placeholder="请输入岗位编码"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select size="small" v-model="formInline.positionStatus" clearable placeholder="请选择状态">
                        <el-option key="-1" label="全部" :value="-1"></el-option>
                        <el-option key="0" label="启用" :value="0"></el-option>
                        <el-option key="1" label="停用" :value="1"></el-option>
                    </el-select>
                </el-form-item> -->
            </el-form>
        </el-card>
        <el-card style="margin-top: 10px;">
            <el-table
                :data="tableData"
                stripe
                v-loading="loading"
                default-expand-all
                row-key="positionId"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
                style="width: 100%"
                :header-cell-style="{ background: '#eef1f6', color: '#606266', fontWeight: 'bolder' }"
            >
                <el-table-column
                    type="index"
                    label="序号"
                ></el-table-column>
                <el-table-column
                    prop="positionCode"
                    label="岗位编码">
                </el-table-column>
                <el-table-column
                    prop="positionName"
                    label="岗位名称">
                </el-table-column>
                <el-table-column
                    prop="sortNo"
                    label="显示顺序">
                </el-table-column>
                <el-table-column
                    prop="positionStatus"
                    label="状态"
                >
                    <template slot-scope="scope">
                        <el-switch
                            v-model="scope.row.positionStatus"
                            active-value="0"
                            inactive-value="1"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            @change="changePOstStatusInfo(scope.row, scope.$index)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column
                    label="创建时间"
                >
                    <template slot-scope="scope">
                        {{ scope.row.createdTime | moment }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                >
                    <template slot-scope="scope">
                        <el-button type="info" size="mini" icon="el-icon-edit" @click="changePostInfo(scope.row)">编辑
                        </el-button>
                        <el-button type="danger" size="mini" icon="el-icon-delete" @click="deletePostItem(scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <!-- 复制岗位 -->
        <el-dialog
            title="复制"
            :visible.sync="copyVisible"
            width="30%"
            top="5vh"
            append-to-body
            :before-close="handleClose"
        >
            <el-form :model="copyRuleForm" :rules="rules" ref="copyRuleForm" label-width="80px" class="demo-ruleForm">
                <el-form-item label="原系统" prop="companyId">
                    <el-select
                        size="small"
                        style="width: 100%;"
                        v-model="copyRuleForm.companyId"
                        placeholder="请选择源系统"
                        clearable
                        filterable>
                        <el-option
                            v-for="item in allCompanyList"
                            :key="item.companyId"
                            :label="item.companyName"
                            :value="item.companyId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="目标系统" prop="oldCompanyId">
                    <el-select
                        size="small"
                        style="width: 100%;"
                        filterable
                        v-model="copyRuleForm.oldCompanyId"
                        placeholder="请选择目标系统"
                        clearable
                        multiple>
                        <el-option
                            v-for="item in allCompanyList"
                            :key="item.companyId"
                            :label="item.companyName"
                            :value="item.companyId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="copyVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmCopy('copyRuleForm')">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { deletePostData, changePostStatus, copyPosition, findPageCompany, getPositionTree } from '@/api/postManage';
import { getSystemData } from "@/api/systemMange";
import { hasBtnPermission } from "@/utils";

export default {
    name: "PostManage",
    data() {
        return {
            title: '',
            loading: false,
            changeVisible: false,
            copyVisible: false,
            totalCount: null,
            // 系统信息
            companyOptions: [],
            // 查询表单
            formInline: {
                companyId: '',
                positionCode: '',
                positionName: '',
                positionStatus: -1,
                sortNo: '',
                userCode: null
            },
            // 表格数据
            tableData: [],
            allCompanyList: [],
            rules: {
                companyId: [
                    { required: true, message: '请选择源系统', trigger: ['change', 'blur'] }
                ],
                oldCompanyId: [
                    { required: true, message: '请选择目标系统', trigger: ['change', 'blur'] }
                ]
            },
            copyRuleForm: {
                companyId: '',
                oldCompanyId: ''
            }
        }
    },
    activated() {
        this.getAllSystemInfo().then(() => {
            !this.formInline.companyId && (this.formInline.companyId = this.companyOptions[0].companyId)
            this.onSubmit()
        })
    },
    methods: {
        // 查询所有系统信息
        async getAllSystemInfo() {
            let searchSystemParams = {
                pageNo: 1,
                pageSize: 100,
                companyName: '',
                userCode: JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            }
            const res = await getSystemData(searchSystemParams);
            if (res.code === '200') {
                this.companyOptions = res.data.list
            } else {
                this.$message.error(res.msg)
            }
        },
        // 查询所有岗位信息
        async getAllPostInfo() {
            this.loading = true;
            this.formInline.userCode = JSON.parse(window.sessionStorage.getItem('userInfo')).userId
            const res = await getPositionTree(this.formInline);
            if (res.code === '200') {
                this.changeType(res.data)
                this.tableData = res.data
            } else {
                this.$message.error(res.msg)
            }
            this.loading = false
        },
        // 循环改变类型
        changeType(arr){
            arr.forEach(item => {
                if(item.children){
                    this.changeType(item.children)
                }
                item.positionStatus = String(item.positionStatus)
            })
        },
        changePostInfo(item) {
            if(item.positionName) {
                if(!hasBtnPermission('sys:position:update')){
                    this.$message.warning('您暂无权限操作')
                    return
                }
            }else{
                if(!hasBtnPermission('sys:position:save')){
                    this.$message.warning('您暂无权限操作')
                    return
                }
            }
            this.$router.push({
                path: '/sys/position/addPosition',
                query: {
                    item: JSON.stringify(item)
                }
            })
        },
        // 查询按钮事件
        onSubmit() {
            if(!hasBtnPermission('sys:position:list')){
                this.$message.warning('您暂无权限操作')
                return
            }
            this.getAllPostInfo()
        },
        // 更新用户状态
        async changePOstStatusInfo(item,index){
            let params = {
                companyId: item.companyId,
                positionId: item.positionId,
                positionStatus: item.positionStatus
            }
            const res = await changePostStatus(params);
            if(res.code === '200'){
                item.positionStatus === "1" ? this.$message.success('禁用成功') : this.$message.success('启用成功')
                this.getAllPostInfo()
            }else{
                this.$message.error(res.msg)

            }
        },
        // 删除岗位
        deletePostItem(item) {
            if(!hasBtnPermission('sys:position:delete')){
                this.$message.warning('您暂无权限操作')
                return
            }
            let params = {
                companyId: item.companyId,
                positionId: item.positionId
            }
            this.$confirm('确定删除该数据吗', '提示')
                .then(_ => {
                    this.confirmDeletePostItem(params)
                })
                .catch(_ => {
                })
        },
        // 确认删除该数据
        async confirmDeletePostItem(params) {
            const res = await deletePostData(params);
            if (res.code === '200') {
                this.$message.success('删除成功')
                this.getAllPostInfo()
            } else {
                this.$message.error(res.msg)
            }
        },
        changePage(e) {
            this.formInline.pageNo = e;
            this.getAllPostInfo()
        },
        handleSizeChange(e){
            this.formInline.pageSize = e;
            this.getAllPostInfo()
        },
        handleClose() {
            this.changeVisible = false
        },
        // 复制岗位
        copyPosition(){
            this.copyVisible = true
            this.getAllPositionList()
        },
        // 查询所有系统信息
        async getAllPositionList(){
            const res = await findPageCompany();
            if(res.code === '200') {
                this.allCompanyList = res.data
            }else{
                this.$message.error(res.msg)
            }
        },
        confirmCopy(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.confirmCopyCompany()
                } else {
                    return false;
                }
            });
        },
        async confirmCopyCompany(){
            const res = await copyPosition(this.copyRuleForm);
            if(res.code === '200'){
                this.$message.success('复制成功')
                this.copyVisible = false
            }else{
                this.$message.error(res.msg)
            }
        }
    }
}
</script>

<style scoped>
::v-deep .el-card__body{
    padding: 20px 20px 0 20px;
}
::v-deep .el-table{
    margin-bottom: 20px;
}
</style>
<style scoped lang="scss">
.post-manage {
    .search-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        margin-left: 20px;
    }
    .pagination{
        margin: 20px 0 0;
    }
}
</style>
